import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import ContactFormCmp from "../../components/ContactFormCmp";

const TDRConsultancy = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        location: "",
        budget: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const submitMessage = (e) => {
        e.preventDefault();
        // console.log(formData);
        // API call or validation logic here
        alert(
            'Due to some technical issues, we could not process your Form Submission.'
        );

        setFormData({
            fullName: "",
            email: "",
            phone: "",
            location: "",
            budget: "",
            message: "",
        });
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            {/*Start breadcrumb area paroller*/}
            <section className="breadcrumb-area">
                <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(/assets/images/services/banners/TDRSERVICES.jpg)' }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="inner-content">
                                <div className="title">
                                    <h2>TDR Consultancy</h2>
                                </div>
                                <div className="breadcrumb-menu">
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                        <li className="active">TDR Consultancy</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb area*/}

            <div className="service-details-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="service-details-sec1">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img className="serv-im" src="/assets/images/Group2.png" alt="Architecture Design" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h3 className="serv-head">TDR Consultancy</h3>
                                        <p className="serv-txt">Transfer of Development Rights (TDR) allows property owners to utilize or sell unused development potential. Our
                                            consultancy guides you through regulations, calculates entitlements, and ensures smooth and efficient transfers.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="serv-sec2">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="serv-sec2-leftsec">
                                    <h3 className="serv-sec2-leftsec-head">What We Offer</h3>
                                    <p className="serv-sec2-leftsec-txt">Transfer of Development Rights (TDR) allows property owners to monetize unused development potential. Our TDR consultancy helps you navigate the complex regulatory landscape, calculate your entitlements, and complete transfers efficiently.</p>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Buying</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Selling</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Claiming</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="serv-sec-3box">
                                        <h3 className="serv-sec-3box-head">Understanding TDR</h3>
                                        <ul className="serv-sec-3box-ul">
                                            <li>• TDR allows transferring unused FSI from one property to another</li>
                                            <li>• Generated from reserved lands, heritage structures, slum rehab</li>
                                            <li>• Can significantly increase project viability</li>
                                            <li>• Requires expert navigation of municipal regulations</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='contactus-section2Right'>
                                    <h3 className='contactus-section2RightHead'>Contact for Service</h3>
                                    <p className='contactus-section2Righttxt'>Fill in your details and we'll get back to you within 24 hours.</p>
                                    <ContactFormCmp serviceName="TDR" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default TDRConsultancy;